var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M771 649L771 677",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 771.5,
    cy: 644.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M766.987 644.19C766.987 640.283 770.288 637.117 774.358 637.117C774.943 637.117 775.511 637.184 776.056 637.308C774.742 636.48 773.187 636 771.519 636C766.814 636 763 639.806 763 644.5C763 649.194 766.814 653 771.519 653C773.814 653 775.895 652.093 777.427 650.62C776.492 651.032 775.454 651.263 774.358 651.263C770.288 651.263 766.987 648.096 766.987 644.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M780.402 643.6L780.37 641.146L778.535 642.719L776.304 642.056L777.112 644.337L775.765 646.381L778.1 646.218L779.499 648.144L780.133 645.763L782.345 644.909L780.402 643.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.d43c044d91b3b21e65395ff7b9a4b9dd.svg";
export { ForwardRef as ReactComponent };